import React from 'react';

// For displaying an error as the entire page.
export const ErrorPage = () => {
  return (
    <div data-testid="error-page" className="jumbotron alert alert-danger">
      <h2>Oops</h2>
      <h3>An error has occurred and been logged.</h3>
    </div>
  );
};

export default ErrorPage;
